<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
        <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{alert_message}}</v-alert>
    </div>
    <!-- Header component -->
    <div> <HeaderComponent :headerTitle="headerText" /></div>
    <loading :active="isLoading" :can-cancel="true" :is-full-page="fullPage" :color="primary_code"></loading>
    <!-- Update  popup  -->
    <v-row justify="center">
      <v-dialog v-model="UpdatePopup" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Update</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="UpdatePopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
          <v-form>
            <v-card-text>
             <v-container>
              <v-row v-for="(row, index) in rows" :key="index">
                    <v-col cols="12" sm="5" md="6">
                      <v-autocomplete 
                      v-model="row.field" 
                      variant="outlined" 
                      :items="getFilteredDocuments(row)" 
                      item-title="label"
                      item-value="field" 
                      label="Select data field"
                      style="max-width: 300px;"
                      :class="index === rows.length - 1 ? 'mb-2' : ''"
                      persistent-placeholder
                      @update:modelValue="changeInfo(row)"
                    >
                      <template v-slot:item="{ props, item }">
                        <v-list-item v-bind="props" title="">
                          {{ item.raw?.label || '' }} {{ item.raw?.is_mandatory ? ' *' : '' }}
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                    <v-span style="text-decoration: underline;color:red;cursor: pointer;font-size: 16px;" v-if="rows.length > 1 && index == rows.length-1" @click="deleteLastRow">Delete</v-span>
                    </v-col>
                    <v-col cols="12" sm="5" md="6">
                    <!-- Use a conditional rendering to show a file input or a text field -->
                      <v-text-field 
                      v-model="row.value" 
                      v-if="rows[index].data_type === 'info'"
                      label="Enter Info" 
                      @keypress="onKeyPress($event,row.label,row)"    
                      :error="hasError"
                      variant="outlined"                      
                      type="text" required
                      >
                    </v-text-field>
                    <v-text-field 
                      v-if="isShow"
                      label="Update" 
                      variant="outlined"
                      v-model="update" 
                      type="text" required
                      disabled
                      >
                    </v-text-field>
                    <!-- <v-text-field 
                      v-model="row.value" 
                      v-if="rows[index].data_type === 'date'"
                      outlined type="date"
                      label="Select Date"
                      :rules="[validateDate]"
                      :max="today"  /> -->

                      <v-menu v-model="row.menu_14" :close-on-content-click="false" :return-value="row.value" transition="scale-transition" offset-y min-width="320px" v-if="rows[index].data_type === 'date'">
                        <template v-slot:activator="{ props }">
                          <v-text-field variant="outlined" hide-details
                            v-model="row.formatted_date"
                            label="Select Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="props"
                          ></v-text-field>
                        </template>
                        <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                          <v-date-picker :max="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerClaimTicketDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                          </v-date-picker>
                          <v-card-action class="d-flex justify-end pb-3">
                            <v-spacer></v-spacer>
                            <v-btn variant="text" class=" text-none" color="primary" @click="row.menu_14= false">Cancel</v-btn>
                            <v-btn variant="text" class=" text-none" color="primary" @click="handleSaveDateByRow(row, 'isDatePickerClaimTicketDate')">Ok</v-btn>
                          </v-card-action>
                        </v-card>
                      </v-menu>
                      <v-file-input
                          v-model="row.file"
                          v-if="row.field && row.data_type !== 'info' && row.data_type !== 'date'"
                          :accept="getAcceptType(row.field, index)" 
                          label="Update"
                          @change="handleFileChangeUpdate(row.file, index)"
                       >
                </v-file-input>
                  </v-col>

                    <!-- <v-col cols="12" sm="4" md="2">
                      <v-btn color="red" @click="deleteRow(index)">Delete</v-btn>
                    </v-col> -->
                  </v-row>
                  <!-- <v-span style="text-decoration: underline;color:red;cursor: pointer;font-size: 16px;" v-if="rows.length > 1" @click="deleteLastRow">Delete</v-span> -->
            </v-container>
              <v-btn
              color="primary"
              dark
              variant="outlined"
              class="ma-2"
              @click="addNewRow(row, index)"
              :disabled="checkDisabilityAddMore()"
            >
              <v-icon color=" mr-1">mdi-plus</v-icon>ADD DATA FIELD
            </v-btn>
            </v-card-text>
            
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <!-- <v-btn outlined class="submit-color mb-3" @click="writeOffItemSubmit" :disabled=" number >0 || !raise_note_against || !debit_amount">submit</v-btn> -->
            <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" :disabled=" number >0 || checkSubmitDisability()" @click="bulkUpdateDocSubmit">Submit</v-btn>
            <v-btn size="small" variant="outlined" color="primary" class="cancel-color text-none mb-3" @click="UpdatePopup = false">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Update popup for pending claim ticket  -->
    <v-row justify="center">
      <v-dialog v-model="updatePopupPendingClaimTicket" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="updatePopupPendingClaimTicket = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-form>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" sm="6" md="6" >
                    <v-menu v-model="menu_14" :close-on-content-click="false" :return-value="claim_ticket_date" transition="scale-transition" offset-y min-width="320px">
                      <template v-slot:activator="{ props }">
                        <v-text-field variant="outlined" hide-details
                          v-model="formatted_claim_ticket_date"
                          label="Insurance claim ticket Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                          :disabled="disabledClaimTicketDate"
                        ></v-text-field>
                      </template>
                      <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                        <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerClaimTicketDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                        </v-date-picker>
                        <v-card-action class="d-flex justify-end pb-3">
                          <v-spacer></v-spacer>
                          <v-btn variant="text" class=" text-none" color="primary" @click="menu_14= false">Cancel</v-btn>
                          <v-btn variant="text" class=" text-none" color="primary" @click="handleSaveDate('menu_14', 'claim_ticket_date', 'isDatePickerClaimTicketDate')">Ok</v-btn>
                        </v-card-action>
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field label="Insurance claim ticket number" variant="outlined" @keypress="onKeyPress" v-model="claim_ticket_number" required :disabled="disabledClaimTicketNum"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="primary" class="cancel-color text-none mb-3" @click="updatePopupPendingClaimTicket = false">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" @click="updatePendingClaimSubmit" :disabled="number>0 || (!claim_ticket_number && !disabledClaimTicketNum) || (!claim_ticket_date && !disabledClaimTicketDate) || (disabledClaimTicketDate && disabledClaimTicketNum)">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Update popup for pending Inspection  -->
    <v-row justify="center">
      <v-dialog v-model="updatePopupPendingInspection" persistent max-width="700px">
        <v-form>
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="updatePopupPendingInspection = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" sm="6" md="6" >
                      <v-menu v-model="menu_141" :close-on-content-click="false" :return-value="inspection_date" transition="scale-transition" offset-y min-width="320px">
                          <template v-slot:activator="{ props }">
                                <v-text-field variant="outlined" hide-details
                                v-model="formatted_inspection_date"
                                label="Insurance Inspection date"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-bind="props"
                                :disabled="disabledInspectionTicketDate"
                                ></v-text-field>
                          </template>
                          <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                            <v-date-picker :min="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerInspectionDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                            </v-date-picker>
                            <v-card-action class="d-flex justify-end pb-3">
                              <v-spacer></v-spacer>
                              <v-btn variant="text" class="text-none " color="primary" @click="menu_141= false">Cancel</v-btn>
                              <v-btn variant="text" class="text-none " color="primary" @click="handleSaveDate('menu_141' , 'inspection_date', 'isDatePickerInspectionDate')">Ok</v-btn>
                            </v-card-action>
                          </v-card>
                      </v-menu>
                    </v-col>
                  <v-col cols="12" sm="4" md="6">
                  <v-file-input
                    v-model="file"
                    accept=".pdf, .png, .eml"
                    :rules="[fileTypeRule]"
                    label="Inspection Report"
                    @change="handleFileChange"
                    :disabled="disabledInspectionReport"
                  ></v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>          
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="primary" class="text-none cancel-color mb-3" @click="updatePopupPendingInspection = false">Cancel</v-btn>
            <!-- <v-btn outlined class="submit-color mb-3" @click="writeOffItemSubmit" :disabled=" number >0 || !raise_note_against || !debit_amount">submit</v-btn> -->
            <v-btn size="small" variant="flat" color="primary" class="text-none mb-3" 
                @click="updatePendingInspectionSubmit" :disabled="number>0  || (!inspection_date && !disabledInspectionTicketDate) || (disabledInspectionTicketDate)">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
      </v-dialog>
    </v-row>
    <!-- Update popup for pending decision   -->
    <v-row justify="center">
      <v-dialog v-model="updatePopupPendingDecision" persistent max-width="700px">
        <v-card class="v-card-100">
        <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span style="font-weight: bold;">Update</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="closePopup">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
          <v-divider :thickness="4" class="m-0" />
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" sm="6" md="6" style="height: 96px;">
                    <v-autocomplete v-model="insu_claim_decision" variant="outlined" :items="insu_claim_item" item-title="name" item-value="id"
                      label="Insurance Claim Decision" style="max-width: 300px;" @update:modelValue="changeDisposition(insu_claim_item)" :disabled="disabledClaimDecision"></v-autocomplete> <br>
                  </v-col>
                  <v-col cols="12" sm="4" md="6" style="height: 96px;">
                    <v-text-field  hide-details label="Approval reference number *" variant="outlined"
                      v-model="approval_ref_number" type="text" required oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/g, '');"  :disabled="disabledRefernceNum"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>                  
                     <v-col cols="6" sm="6" md="6" style="height: 96px;">
                    <v-text-field label="Approved Amount (₹) *" variant="outlined" @input="clearInvalidInputApproved" v-model="formattedApprovedAmount" required :disabled="disabledApprovedAmt"></v-text-field>
                    </v-col>
                     <v-col cols="6" sm="6" md="6" style="height: 96px;" v-if="!disabledApprovedAmt">
                    <v-text-field label="Excess (₹)" variant="outlined" :rules="[exceedingZeroRule]" v-model="formattedExcessAmount" required></v-text-field>
                    </v-col>                 
                </v-row>
                <v-row v-if="!disabledApprovedAmt">
                   <v-col cols="6" sm="6" md="6" style="height: 96px;">
                    <v-text-field  label="Non Standard Deduction (₹)" variant="outlined" :rules="[exceedingZeroRule]" v-model="formattedNonstdAmount" required :disabled="disabledApprovedAmt"></v-text-field>
                    </v-col>
                     <v-col cols="6" sm="6" md="6" style="height: 96px;">
                    <v-text-field label="Any Other Deduction (₹)" variant="outlined" :rules="[exceedingZeroRule]" v-model="formattedAnyOtherDedAmount" required :disabled="disabledApprovedAmt"></v-text-field>
                    </v-col>                 
                </v-row>
                <v-row v-if="!disabledApprovedAmt">
                  <v-col cols="6" sm="6" md="6" style="height: 96px;">
                  <v-autocomplete v-model="salvage_action" variant="outlined" :items="filteredSalvageItems" item-title="name" item-value="name"
                    :label="organization_name ? 'Insurance Decision on Salvage *' : 'Salvage Action'" style="max-width: 300px;" @update:modelValue="changeSalvageAction()"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4" md="6" style="height: 96px;">
                    <v-text-field  type="number" v-model="salvage_value" variant="outlined" required
                      label="Salvage Value *" style="max-width: 300px;" @input="clearInvalidInput" :disabled="salvage_action == 'No Action'"></v-text-field>
                      <!-- :rules="[salvage_rule]" :disabled="disabledSalvageValue" -->
                  </v-col>
                </v-row>
                 <v-row v-if="salvage_action == 'Liquidate'">
                  <v-col cols="6" sm="6" md="6" style="height: 96px;">
                  <v-autocomplete v-model="buyer_code" variant="outlined" :items="buyer_code_items" item-title="client_vendor_code" item-value="id" label="Buyer Code" style="max-width: 300px;"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4" md="6" style="height: 96px;"></v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6" style="height: 96px;">
                    <v-file-input v-model="insurance_approval_attachment" accept=".pdf, .jpg, .jpeg, .png, .eml" label="Insurance Approval Mail Attachment" />
                    </v-col>
                  <v-col cols="12" sm="4" md="6" style="height: 96px;">
                    <v-text-field variant="outlined" hide-details label="Approval Reference Text" outlined v-model="approval_reference_text" type="text" oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/g, '');"  :disabled="disabledAppRefText"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="primary" class="text-none cancel-color mb-3" @click="closePopup">Cancel</v-btn>
            <!-- <v-btn outlined class="submit-color mb-3" @click="writeOffItemSubmit" :disabled=" number >0 || !raise_note_against || !debit_amount">submit</v-btn> -->
            <v-btn size="small" variant="flat" color="primary" class="text-none mb-3" @click="updatePendingDecisionSubmit" :disabled="!isSubmitButtonEnabled">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- data detail popup -->
    <v-row justify="center">
      <v-dialog v-model="datadetailpopup" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="datadetailpopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
            <v-card-text>
              <v-container>
                <div>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" >
                        <span style="font-weight: 500;">Article id</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.sku_code ? item_details.sku_code : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Article Description</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.item_description ? item_details.item_description : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Incident Location</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.incident_location ? item_details.incident_location : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Incident Date</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.incident_date ? item_details.incident_date : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Vendor Responsible For Damage</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.responsible_vendor ? item_details.responsible_vendor : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row v-if="active_tab == 'Pending Information'">
                      <v-col cols="1" sm="4" md="3">
                          <span style="font-weight: 500;">Information / Documents</span>
                        </v-col>
                        <v-col>
                          <span style="font-weight: 500;"><hr></span>
                        </v-col>
                    </v-row>
                    <v-row v-for="doc in require_doc" :key="doc.field">
                        <v-col cols="6" sm="6" md="6">
                          <span style="font-weight: 600; font-size: 14px; color: #646464;">
                            {{ doc.label }} 
                            <template v-if="doc.is_mandatory">*</template>
                          </span>
                        </v-col>
                        <v-col cols="12" sm="4" md="6">
                          
                            <span v-if="Array.isArray(doc.value) && doc.value.length > 0">
                              <ol class="alignitems">
                            <li v-for="(item, itemIndex) in doc.value" :key="itemIndex">
                              <a :href="item.url" 
                                    target="_blank" 
                                    style="color: #0357D0;
                                    font-size: 14px;
                                    font-weight: 600;" class="cursor-pointer">{{ item.name }}</a>
                            </li>
                          </ol>
                            </span>
                            <span v-else-if="doc.value && !Array.isArray(doc.value)" >
                              <a :href="doc.value.url" 
                                target="_blank"
                                style="color: #0357D0;
                                    font-size: 14px;
                                    font-weight: 600;"
                                    class="cursor-pointer"
                                >{{ doc.value.name }}</a>
                                <span v-if="doc.data_type == 'info'">{{ doc.value }}</span>
                                <span v-else-if="doc.data_type == 'date'">{{ doc.value ? dateFormat(doc.value) : '-' }}</span>
                            </span>
                            <span v-else>
                              <a style="color: #0357D0;
                                  font-size: 14px;
                                  font-weight: 600;"
                                  @click="updateItemPopup(doc)"
                                  class="cursor-pointer"
                                  >update</a>                                  
                            </span>
                          
                        </v-col>
                  </v-row>
                  <v-row v-if="active_tab == 'Pending Inspection' || active_tab == 'Pending Decision'">
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Inurance Claim Ticket Number</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.claim_ticket_number ? item_details.claim_ticket_number: 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row v-if="active_tab == 'Pending Inspection' || active_tab == 'Pending Decision'">
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Inurance Claim Ticket Date</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.claim_ticket_date ? item_details.claim_ticket_date: 'N/A'}}
                      </v-col>
                    </v-row>
                  </div>
              </v-container>
            
            </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- item detail popup in pending claim ticket -->
    <v-row justify="center">
      <v-dialog v-model="dataDetailPopupInClaimTicket" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="text solo" class="text" @click="dataDetailPopupInClaimTicket = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="2" class="border-opacity-25 m-0"/>
            <v-card-text>
              <v-container>
                <div>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" >
                        <span style="font-weight: 500;">Article id</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.sku_code ? item_details.sku_code : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Article Description</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.item_description ? item_details.item_description : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Incident Location</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.incident_location ? item_details.incident_location : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Incident Date</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.incident_date ? item_details.incident_date : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Vendor Responsible For Damage</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.responsible_vendor ? item_details.responsible_vendor : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row v-for="doc in require_doc" :key="doc.field">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600; font-size: 14px; color: #646464;">
                      {{ doc.label }} 
                      <template v-if="doc.is_mandatory">*</template>
                    </span>
                  </v-col>
                 <v-col cols="6">
                <!-- Display list of items if value is an array -->
                <template v-if="Array.isArray(doc.value) && doc.value?.length > 0">
                  <ol>
                    <li v-for="(item, itemIndex) in doc.value" :key="itemIndex">
                      <a :href="item?.url" target="_blank" style="color: #0357D0;">{{ item?.name }}</a>
                    </li>
                  </ol>
                </template>

                <!-- Display single value if it's an object -->
                <template v-else-if="doc.value && !Array.isArray(doc.value)">
                  <span v-if="typeof doc.value == 'object'">
                    <a :href="doc?.value?.url" target="_blank" style="color: #0357D0;">{{ doc?.value?.name }}</a>
                  </span>
                  <span v-else-if="doc.data_type == 'date'">
                    {{ doc.value ? dateFormat(doc.value) : '-' }}
                  </span> 
                  <span v-else>
                    {{ doc.value }}
                  </span>
                </template>
                <!-- Display N/A if no value is present -->
                <span v-else>N/A</span>
                </v-col>
                </v-row>
                <v-row v-if="active_tab == 'Pending Inspection'">
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Insurance Claim Ticket Number</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.claim_ticket_number ? item_details.claim_ticket_number: 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row v-if="active_tab == 'Pending Inspection'">
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Insurance Claim Ticket Date</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.claim_ticket_date ? item_details.claim_ticket_date: 'N/A'}}
                      </v-col>
                    </v-row>
                  </div>
              </v-container>
            
            </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Item detail popup in pending decision -->
    <v-row justify="center">
      <v-dialog v-model="dataDetailPopupPendingDecision" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="dataDetailPopupPendingDecision = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
            <v-card-text>
              <v-container>
                <div>
                    <v-row>
                      <v-col cols="6" sm="6" md="6" >
                        <span style="font-weight: 500;">Article id</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.sku_code ? item_details.sku_code : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Article Description</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.item_description ? item_details.item_description : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Incident Location</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.incident_location ? item_details.incident_location : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Incident Date</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.incident_date ? item_details.incident_date : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Vendor Responsible For Damage</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.responsible_vendor ? item_details.responsible_vendor : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Inspection Report</span>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <a :href="inspection_report_data.url"  
                                 target="_blank"
                                  style="color: #0357D0;
                                  font-size: 14px;
                                  font-weight: 600;"
                                  >{{ inspection_report_data.name }}</a>
                      </v-col>
                    </v-row>
                    <v-row v-for="doc in require_doc" :key="doc.field">
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 600; font-size: 14px; color: #646464;">
                      {{ doc.label }} 
                      <template v-if="doc.is_mandatory">*</template>
                    </span>
                  </v-col>
                  <v-col cols="6">
                <!-- Display list of items if value is an array -->
                <template v-if="Array.isArray(doc.value) && doc.value?.length > 0">
                  <ol>
                    <li v-for="(item, itemIndex) in doc.value" :key="itemIndex">
                      <a :href="item?.url" target="_blank" style="color: #0357D0;">{{ item?.name }}</a>
                    </li>
                  </ol>
                </template>

                <!-- Display single value if it's an object -->
                <template v-else-if="doc.value && !Array.isArray(doc.value)">
                  <span v-if="typeof doc.value == 'object'">
                    <a :href="doc?.value?.url" target="_blank" style="color: #0357D0;">{{ doc?.value?.name }}</a>
                  </span>
                  <span v-else-if="doc.data_type == 'date'">
                    {{ doc.value ? dateFormat(doc.value) : '-' }}
                  </span> 
                  <span v-else>
                    {{ doc.value }}
                  </span>
                </template>
                <!-- Display N/A if no value is present -->
                <span v-else>N/A</span>
                </v-col>
                </v-row>
                  <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Inurance Claim Ticket Number</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.claim_ticket_number ? item_details.claim_ticket_number: 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <span style="font-weight: 500;">Inurance Claim Ticket Date</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="6">
                        {{ item_details.claim_ticket_date ? item_details.claim_ticket_date: 'N/A'}}
                      </v-col>
                    </v-row>
                  </div>
              </v-container>
            
            </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
      <!-- item detail popup in pending disposition -->
    <v-row justify="center">
      <v-dialog v-model="datadetailpopupdisposition" persistent max-width="700px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Tag ID: {{ tag_number }}</span>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="datadetailpopupdisposition = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
            <v-card-text>
              <v-container>
                <div>
                    <v-row>
                      <v-col cols="6" sm="3" md="3" >
                        <span style="font-weight: 500;">Article id</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.sku_code ? item_details.sku_code : 'N/A'}}
                      </v-col>
                      <v-col cols="6" sm="3" md="3" >
                        <span style="font-weight: 500;">Inspection date</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.inspection_date ? item_details.inspection_date : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Article Description</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.item_description ? item_details.item_description : 'N/A'}}
                      </v-col>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Inspection Report</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        <a :href="inspection_report_data?.url"  
                                 target="_blank"
                                  style="color: #0357D0;
                                  font-size: 14px;
                                  font-weight: 600;"
                                  >{{ inspection_report_data?.name }}</a>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Incident Location</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.incident_location ? item_details.incident_location : 'N/A'}}
                      </v-col>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Insurance claim Decision</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.claim_decision ? item_details.claim_decision : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Incident Date</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.incident_date ? item_details.incident_date : 'N/A'}}
                      </v-col>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Approval Ref No.</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.approval_ref_number ? item_details.approval_ref_number : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Type Of Claimable Damage</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.claimable_danage ? item_details.claimable_danage : 'N/A'}}
                      </v-col>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Approval Date</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.approval_date ? item_details.approval_date : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Vendor Responsible For Damage</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.responsible_vendor ? item_details.responsible_vendor : 'N/A'}}
                      </v-col>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Incident Date</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.incident_date ? item_details.incident_date : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Insurance Claim Ticket Number</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.claim_ticket_number ? item_details.claim_ticket_number : 'N/A'}}
                      </v-col>
                      <v-col cols="6" sm="3" md="3">
                        <span style="font-weight: 500;">Inurance Claim Ticket date</span>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        {{ item_details.claim_ticket_date ? item_details.claim_ticket_date : 'N/A'}}
                      </v-col>
                    </v-row>
                    <v-row v-for="doc in require_doc" :key="doc.field">
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600; font-size: 14px; color: #646464;">
                      {{ doc.label }} 
                      <template v-if="doc.is_mandatory">*</template>
                    </span>
                  </v-col>
                  <v-col cols="6">
                    <!-- Display list of items if value is an array -->
                    <template v-if="Array.isArray(doc.value) && doc.value?.length > 0">
                      <ol>
                        <li v-for="(item, itemIndex) in doc.value" :key="itemIndex">
                          <a :href="item?.url" target="_blank" style="color: #0357D0;">{{ item?.name }}</a>
                        </li>
                      </ol>
                    </template>

                    <!-- Display single value if it's an object -->
                    <template v-else-if="doc.value && !Array.isArray(doc.value)">
                      <span v-if="typeof doc.value == 'object'">
                        <a :href="doc?.value?.url" target="_blank" style="color: #0357D0;">{{ doc?.value?.name }}</a>
                      </span>
                      <span v-else-if="doc.data_type == 'date'">
                        {{ doc.value ? dateFormat(doc.value) : '-' }}
                      </span> 
                      <span v-else>
                        {{ doc.value }}
                      </span>
                    </template>
                    <!-- Display N/A if no value is present -->
                    <span v-else>N/A</span>
                </v-col>
                </v-row>
                  </div>
              </v-container>
            
            </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  <!-- update popup in detail item -->
    <v-row justify="center">
      <v-dialog v-model="updatepopinitem" persistent max-width="700px">
        <v-form>
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <span>Update</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="closeItempopup">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="border-opacity-25 m-0"/>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6" sm="6" md="6" >
                    <v-text-field 
                      hide-details 
                      label="Label Name" 
                      variant='outlined'
                      v-model="item_label_name" 
                      type="text" required
                      readonly
                      ></v-text-field>
                    </v-col>
                  <v-col cols="12" sm="4" md="6">
                  <v-file-input
                    v-model="file"
                    v-if="this.data_type_upload != 'info' && this.data_type_upload != 'date'"
                    :accept= "acceptedFileType" 
                    label="Update"
                    @change="handleFileChange"

                  ></v-file-input>
                <v-text-field 
                      v-if="this.data_type_upload === 'info'" 
                      hide-details 
                      label="Enter Info" 
                      variant='outlined'
                      v-model="data_type_info" 
                      @keypress="onInfoDataPress($event,item_label_name)"
                      type="text" required>
                    </v-text-field>
                    <!-- <v-text-field 
                      v-model="data_type_info" 
                      v-if="this.data_type_upload == 'date'" 
                      variant='outlined'
                      type="date"
                      label="Select Date"
                      :rules="[validateDate]"
                      :max="today" /> -->
                      <v-menu v-model="menu_14" :close-on-content-click="false" :return-value="data_type_info" transition="scale-transition" offset-y min-width="320px" v-if="this.data_type_upload == 'date'">
                      <template v-slot:activator="{ props }">
                        <v-text-field variant="outlined" hide-details
                          v-model="formatted_data_type_info"
                          label="Select Date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                        ></v-text-field>
                      </template>
                      <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                        <v-date-picker :max="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerClaimTicketDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                        </v-date-picker>
                        <v-card-action class="d-flex justify-end pb-3">
                          <v-spacer></v-spacer>
                          <v-btn variant="text" class=" text-none" color="primary" @click="menu_14= false">Cancel</v-btn>
                          <v-btn variant="text" class=" text-none" color="primary" @click="handleSaveDate('menu_14', 'data_type_info', 'isDatePickerClaimTicketDate')">Ok</v-btn>
                        </v-card-action>
                      </v-card>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>          
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" color="primary"  class="text-none cancel-color mb-3" @click="closeItempopup">Cancel</v-btn>
            <!-- <v-btn outlined class="submit-color mb-3" @click="writeOffItemSubmit" :disabled=" number >0 || !raise_note_against || !debit_amount">submit</v-btn> -->
            <v-btn size="small" color="primary" variant="flat" class="text-none mb-3" @click="updateInfoDocItemSubmit()" :disabled="number >0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
      </v-dialog>
    </v-row>

    <!-- Reject popup -->
    <v-row justify="center">
      <v-dialog v-model="rejectpopup" persistent max-width="366px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Reject</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="rejectColsePopup()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
            <v-card-text>
              <v-container>
                  <v-col cols="6" sm="12" md="12" style="height: 96px;">
                    <v-autocomplete 
                    v-model="rejectdisposition" 
                    variant="outlined" 
                    :items="reject_disposition_lit" 
                    item-title="id" 
                    item-value="code"
                    label="Disposition" 
                    style="max-width: 300px;"
                    ></v-autocomplete> <br>
                    </v-col>               
              </v-container>
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="flat" color="primary" class="text-none mb-3" @click="adminRejectItem" :disabled="!rejectdisposition">Submit</v-btn>
            <v-btn size="small" variant="outlined" color="primary" class="text-none cancel-color mb-3" @click="rejectColsePopup">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Update Amount -->
    <v-row justify="center">
      <v-dialog v-model="updateAmountPopup" persistent max-width="366px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Claim Amount (₹)</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="closePopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
            <v-card-text>
              <v-container>
                  <v-col cols="6" sm="12" md="12" style="height: 96px;">
                    <v-text-field label="Update Amount (₹)" variant="outlined" v-model="formattedUpdateAmount" @keypress="onKeyPressUpdate" oninput="this.value = this.value.replace(/[^0-9,]/g, '');" :rules="[positiveNumberRule]" required></v-text-field>
                    </v-col>               
              </v-container>
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" color="primary" variant="flat" class="text-none mb-3" @click="updateAmountSubmit" :disabled="!update_amount">Submit</v-btn>
            <v-btn size="small" variant="outlined" color="primary" class="text-none cancel-color mb-3" @click="closePopup">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="rejectsussesspopup" persistent max-width="424px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="rejectsussesspopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="text-center" v-if="(active_tab == 'Pending Disposition') && currentUser.roles.includes('central_admin')">
              <span> {{ successmessage }}</span>
            </v-card-text>
            <v-card-text class="text-center" v-if="(active_tab == 'Pending Disposition') && currentUser.roles.includes('default_user')">
              <span>{{ successmessage }}</span>
            </v-card-text>
            <v-card-text class="text-center" v-if="this.active_tab != 'Pending Disposition'">
              <span> {{ successmessage }}</span>
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="flat" color="primary" class="mb-3" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Approve confirm popup -->
    <v-row justify="center">
      <v-dialog v-model="approveconfirmpopup" persistent max-width="424px">
        <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="approveconfirmpopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="text-center" v-if="(active_tab == 'Pending Disposition') && currentUser.roles.includes('central_admin')">
              <span> Are you sure you want to Approve?</span>
            </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn size="small" variant="flat" color="primary" class="text-none mb-3" @click="adminApproveItem">Yes</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-insurance" v-model="filteWithSubPopup" persistent max-width="1224px">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-text-field color="primary" prepend-inner-icon="mdi-magnify"  v-model="aricle_id_search" label="Article Id" style="max-width: 300px;" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
            <v-text-field color="primary" prepend-inner-icon="mdi-magnify"  v-model="incident_info_search" label="Incident Location" style="max-width: 300px;" class="ma-2" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
              <v-menu v-model="menu_171" :close-on-content-click="false" :return-value="incdent_date_search"
                    transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ props }">
                        <v-text-field 
                          color="primary"
                          v-model="formattedToDate"
                          label="Incident date"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          variant="outlined"
                          style="max-width: 300px;"
                          v-bind="props"
                          :rules="inputRules"
                        ></v-text-field>
                      </template>
                      <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                        <v-date-picker :max="new Date().toISOString().substr(0, 10)" v-model="isDatePickerIncidentDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                        </v-date-picker>
                        <v-card-action class="d-flex justify-end pb-3">
                          <v-spacer></v-spacer>
                          <v-btn variant="text" class="text-none " color="primary" @click="menu_171 = false">Cancel</v-btn>
                          <v-btn variant="text" class="text-none " color="primary" @click="handleSaveDate('menu_171' , 'incdent_date_search', 'isDatePickerIncidentDate')">Ok</v-btn>
                        </v-card-action>
                      </v-card>
                  </v-menu>
            <v-text-field color="primary" prepend-inner-icon="mdi-magnify"  v-model="claimabe_damage_search" label="Claimable Damage Type" style="max-width: 300px;" class="ma-2" variant='outlined' v-on:keyup.enter="loadData(active_tab)"></v-text-field>
             <v-autocomplete  color="primary" style="max-width: 290px !important;"
                  v-model="putaway_filter" variant="outlined" :items="puttawayList"
                   label="Putaway Status" class="ma-2">
                </v-autocomplete>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" variant="outlined" text color="primary" class="text-none" @click="closeFilterpopup">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" @click="applyFilterFunc" class="text-none" :disabled="number > 0">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Tabs -->
    <v-card class="v-card-100 mt-6">
      <v-tabs color="primary"  v-model="tab_index">
        <v-tab ripple style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')"
          v-for="(tab, index) in tabs" :key="index" class="tab-color">{{tab}}</v-tab>
      </v-tabs>
    </v-card>
    
    <v-card-title style="padding: 25px 25px 5px 15px;" class="action-style">
        <!-- Search fields -->
        <v-row>
          <v-combobox class="text-left m-3 mr-0" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;"> </v-combobox>
          <v-text-field color="primary" class="m-3" prepend-inner-icon="mdi-magnify"  :disabled="!select_field" v-model="pending_info_search" v-no-edge-space label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
      <!-- Actions buttons -->
      <v-spacer></v-spacer>
      <v-card-actions style="margin-bottom: 25px;">
        <v-btn class="ma-2 text-none" color="primary" size="x-large" :disabled="(this.selected.length == 0)"  variant="flat"  v-if="active_tab == 'Pending Information' && (isActionAllowed(role) || role == 'warehouse_manager')" @click="updatedialog">Update</v-btn>
        <v-btn class="ma-2 text-none" size="x-large" color="primary" variant="flat" :disabled="(this.selected.length == 0)"  v-if="active_tab == 'Pending Claim Ticket' && isActionAllowed(role)" @click="updatedialogPCT">Update</v-btn>
        <v-btn class="ma-2 text-none" size="x-large" color="primary" variant="flat" :disabled="(this.selected.length == 0)"  v-if="(active_tab == 'Pending Inspection' && (isActionAllowed(role) || role == 'warehouse_manager'))" @click="updatedialogPCT">Update</v-btn>
        <v-btn class="ma-2 text-none" size="x-large"  color="primary" variant="flat" :disabled="(this.selected.length == 0) || this.selected.length > 1"  v-if="active_tab == 'Pending Decision' && isActionAllowed(role)" @click="updatedialogPCT">Update</v-btn>
        <v-btn class="ma-2 text-none" size="x-large" color="primary" v-if="(active_tab !== 'Pending Disposition' && active_tab !== 'Pending For Approval') && (isActionAllowed(role) || ((active_tab == 'Pending Information' || active_tab == 'Pending Inspection') && role == 'warehouse_manager'))" variant="flat" @click="downloadInventory">Download</v-btn>
        <v-btn class="ma-2 text-none" size="x-large" color="primary" v-if="(active_tab !== 'Pending Disposition' && active_tab !== 'Pending For Approval') && (isActionAllowed(role) || ((active_tab == 'Pending Information' || active_tab == 'Pending Inspection') && role == 'warehouse_manager'))" variant="flat" @click="navigateToFileUpload">Upload</v-btn>
        <v-btn class="ma-2 text-none" size="x-large" color="success" variant="flat" :disabled="(this.selected.length == 0)"  v-if="(active_tab == 'Pending Disposition') && currentUser.roles.includes('central_admin') && isActionAllowed(role)" @click="approveConfirmPopup">Approve</v-btn>
        <v-btn class="ma-2 text-none" size="x-large" color="primary" variant="flat"  :disabled="(this.selected.length == 0)"  v-if="(active_tab == 'Pending Disposition') && currentUser.roles.includes('central_admin') && isActionAllowed(role)" @click="rejectDialog">Reject</v-btn>

          <v-flex style="position: relative; top: 1px;">
          <!-- <v-autocomplete 
            v-if="(active_tab == 'Pending Disposition') && currentUser.roles.includes('default_user')"
            v-model="selectedDisposition"
            color="primary"
            :items="disposition_item"
            item-title="code"
            item-value="id"
            label="ASSIGN DISPOSITION"
            class="ma-2"
            @change="assignDisposition"
          style="position: relative;bottom: 22px;width: 200px;"    
          ></v-autocomplete> -->
          <v-menu offset-y v-if="(active_tab == 'Pending Disposition') && currentUser.roles.includes('default_user') && isActionAllowed(role)">
            <template v-slot:activator="{ props }">
              <v-btn :color="selected.length==0? '' : 'primary'" variant="flat" size="x-large" v-bind="props" class="ma-2 mb-3 field assign_dispo_button text-none" :disabled="selected.length==0">
                Assign Disposition
                <v-icon :color="selected.length==0? 'grey' : 'white'" dark>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in disposition_item" :key="index" @click="assignDisposition(item.id)">
                <v-list-item-title>{{ item.code }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-flex>
    </v-card-actions>
    <!-- Filter -->
    <v-expansion-panels class="custom-control_outlined m-0 pt-4" ref = "filterPopupRef" readonly style="max-width: 300px; margin-bottom: 16px; min-height: 52px;" v-if="active_tab !== 'Pending For Approval'">
        <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 52px" >
          <v-expansion-panel-title>Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
      </v-row>
    </v-card-title>
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover 
          density="compact" 
          :search="search" 
          v-model="selected" 
          show-select
          disable-pagination 
          :hide-default-footer="true"
          :headers="headers" 
          :items="table_data" 
          :loading="loading" 
          :items-per-page="pageSize"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
          >
          <template #[`header.disposition_age`]="{ column }">
            <span>{{ column.title }}
              <AgeingTooltip />
            </span>
          </template>
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key === 'claim_amount' && !item.update">
                <span>
                  {{ item.claim_amount ? item.claim_amount.toLocaleString('en-IN') : '-' }}
                </span>
              </span>
              <span v-else-if="header.key === 'benchmark_price' && !item.update">
                <span>{{ item.benchmark_price ? item.benchmark_price.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key === 'net_recovery' && !item.update">
                <span>{{ item.net_recovery ? item.net_recovery.toLocaleString('en-IN') : '-' }}</span>
              </span>
              <span v-else-if="header.key == 'tag_number'">
                <a href="#" @click.prevent="itemDetailpopup(item)" style="color: #1976d2 !important; cursor: pointer !important;"><u>{{ item.tag_number }}</u></a>
              </span> 
              <span v-else-if="header.key == 'action'">
                <span v-if="active_tab == 'Pending Claim Ticket'">
                <img src="@/assets/images/job_sheet.png" @click="updateAmount(item)">
                </span>              
              </span> 
              <span v-else-if="header.key !== 'tag_number' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
            
          <!-- <template #[`item.tag_number`]="{ item }">
              <a @click="itemDetailpopup(item)"  style="color: #1976d2;" class="cursor-pointer">
                <u> {{ item.tag_number }}</u>
              </a>
            
            </template> -->
            <!-- <template #[`item.action`]="{ item }">
              <span v-if="active_tab == 'Pending Claim Ticket'">
                <img src="@/assets/images/job_sheet.png" @click="updateAmount(item)">
              </span>
            </template> -->
            <!-- <template #[`item.benchmark_price`]="{ item }">
              <span>{{ item.benchmark_price ? item.benchmark_price.toLocaleString('en-IN') : '-' }}</span>
            </template>
            <template #[`item.net_recovery`]="{ item }">
              <span>{{ item.net_recovery ? item.net_recovery.toLocaleString('en-IN') : '-' }}</span>
            </template>
            <template #[`item.claim_amount`]="{ item }">
              <span>{{ item.claim_amount ? item.claim_amount.toLocaleString('en-IN') : '-' }}</span>
            </template> -->
            <!-- <template #[`item.responsible_vendor`]="{ item }">
              <span>{{ item.responsible_vendor ? item.responsible_vendor : '-' }}</span>
            </template>
            <template #[`item.item_description`]="{ item }">
              <span>{{ item.item_description ? item.item_description : '-' }}</span>
            </template>
            <template #[`item.serial_number`]="{ item }">
              <span>{{ item.serial_number ? item.serial_number : '-' }}</span>
            </template>
            <template #[`item.remarks`]="{ item }">
              <span>{{ item.remarks ? item.remarks : '-' }}</span>
            </template>
            <template #[`item.sub_location_name`]="{ item }">
              <span>{{ item.sub_location_name ? item.sub_location_name : '-' }}</span>
            </template>  -->
            <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
            <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>
  </v-card>
</template>

  <script>
    // import $ from 'jquery'
    // import Editor from "@tinymce/tinymce-vue";
    import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
    import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
    import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
    // import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';
    // import { securedAxiosInstance, plainAxiosInstance } from '@/backend/axios'
    // import { strict } from 'assert';
    import { required } from 'vuelidate/lib/validators';
    import { mixinHelper } from "@//mixins/mixin-helper.js";
    import Loading from 'vue-loading-overlay';

    export default {
      mixins: [mixinHelper],
      props: {
      fileTypeMapping: {
        type: Object,
        default: () => ({
          image: [
          'image/png', 'image/x-png', 'image/gif', 'image/jpeg'
          ],
          video: 'video/mp4',
          doc: 'application/pdf'
        })
      },
      itemData: {
        type: Object,
        required: true
      }
    },
      computed: {
        today() {
          const date = new Date();
          return date.toISOString().split('T')[0];
        },
      acceptedFileType() {
        const fileType = this.fileTypeMapping[this.data_type_upload];
        return fileType ? fileType : '';
      },
      filteredSalvageItems() {
        return this.salvage_item
          .filter(item => item.id !== 'liquidate')
          .map(item => {
            if (item.id === 'salvage_value') {
              return { ...item, name: 'Liquidate' };
            }
            return item;
          });
      },
      fileTypeRule() {
        return (value) => {
          if (!!value) {
          this.invalidFileType = false;
          return true;
        }
          const allowedTypes = ['.png', '.pdf', '.eml'];
          const fileType = value && value.length && value[0].name ? value[0].name.slice(value[0].name.lastIndexOf('.')) : '';
          this.invalidFileType = !allowedTypes.includes(fileType);
          return !this.invalidFileType || 'Invalid file type';
        };
      },
      formattedApprovedAmount: {
          get() {
            if (this.approved_amount !== null && this.approved_amount !== undefined && this.approved_amount !== '') {
              return Number(this.approved_amount).toLocaleString('en-IN');
            }
            return '';
          },
          set(value) {
            const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
            if (isNaN(numericValue)) {
              this.approved_amount = '';
              return;
            }
            if (this.insu_claim_decision === 'rejected') {
              this.approved_amount = numericValue;
            } else {
              this.approved_amount = numericValue > 0 ? numericValue : '';
            }
          }
        },
      formattedUpdateAmount : {
        get() {
          return (this.update_amount).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.update_amount = Math.max(parseFloat(numericValue), '');
        }
      },
      formattedExcessAmount : {
        get() {
          return (this.excess_amount).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.excess_amount = Math.max(parseFloat(numericValue), '');
        }
      },
      formattedNonstdAmount : {
        get() {
          return (this.nstd_deduction).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.nstd_deduction = Math.max(parseFloat(numericValue), '');
        }
      },
      formattedAnyOtherDedAmount : {
        get() {
          return (this.any_other_deduction).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.any_other_deduction = Math.max(parseFloat(numericValue), '');
        }
      },
      formattedToDate(){
        if (this.incdent_date_search) {
          const date = new Date(this.incdent_date_search);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return '';
      },
      formatted_claim_ticket_date(){
        if (this.claim_ticket_date) {
          const date = new Date(this.claim_ticket_date);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return '';
      },
      formatted_data_type_info(){
        if (this.data_type_info) {
          const date = new Date(this.data_type_info);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return '';
      },
      formatted_inspection_date(){
        if (this.inspection_date) {
          const date = new Date(this.inspection_date);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        }
        return '';
      },
      isSubmitButtonEnabled() {
        if (this.active_tab === 'Pending Decision') {
          const hasBaseFields =
            this.insu_claim_decision &&
            this.approval_ref_number &&
            this.formattedApprovedAmount &&
            this.formattedApprovedAmount.toString().trim() !== '';

          if (this.insu_claim_decision === 'approved' || this.insu_claim_decision === 'partially_approved') {
            if (!this.salvage_action) return false;

            if (this.salvage_action === 'Liquidate') {
              return (
                hasBaseFields &&
                this.salvage_value !== null &&
                this.salvage_value !== undefined &&
                this.salvage_value !== ''
              );
            }

            // salvage_action is not 'Liquidate' → salvage_value not required
            return hasBaseFields;
          }

          if (this.insu_claim_decision === 'rejected') {
            return hasBaseFields;
          }
        }

        return false;
      }
    },

      data() {
        return {
          headerText: "Insurance", 
          number:0,
          infoDataType:[], 
          isShow:true,    
          file: '',
          binaryData:'',
          alert_type: null,
          alert_message:'',
          menu: false,
          claimSubmissionDate: "",
          insuranceSubmissionDialog: false,
          loading: false,
          attachment: "",
          alert: false,
          active_tab: "Pending Information",
          files: [],
          selected_item: {},
          selected: [],
          filteWithSubPopup: false,
          select_field_items: [
                 {
                    "name":"Tag ID",
                    "id": "tag_number"
                  },
                  {
                    "name":"Serial Number",
                    "id": "serial_number"
                  },
                  {
                    "name":"IRD Number",
                    "id": "ird_number"
                  },
                  {
                    "name":"IRRD Number",
                    "id": "irrd_number"
                  }
          ],
          select_field:null,
          tabs: [
            "Pending Information",
            "Pending Claim Ticket",
            "Pending Inspection",
            "Pending Decision",
            "Pending Disposition",
            "Pending For Approval"
          ],
          headers: [
          { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false,minWidth:"200px" },
          {title: "Incident Location", key: "aisle_location",minWidth:"200px"},
          { title: "Article Id", key: "sku_code",minWidth:"200px" },
          { title: "Article Description", key: "item_description",minWidth:"200px" },
          { title: "Incident date", key: "grade",minWidth:"200px" },
          { title: "Damage Type", key: "sub_location",minWidth:"200px" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Responsible Vendor", key: "distribution_center",minWidth:"200px" }
        ],
        table_data: [],
        page : 1 ,
        totalPages : 1,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        pending_info_search:'',
        UpdatePopup: false,
        pending_documents:[],
        pending_doc:'',
        update:'',
        rows: [
                {
                  field: "",
                  file: '',
                  key:'',
                  data_type:'',
                  label:''
                }
          ],
      
      updatePopupPendingClaimTicket: false,
      claim_ticket_date: '',
      isDatePickerClaimTicketDate: new Date(),
      claim_ticket_number:'',
      updatePopupPendingInspection:false,
      updatePopupPendingDecision:false,
      inspection_date: '',
      isDatePickerInspectionDate: new Date(),
      menu_141: false,
      menu_14:false,
      insu_claim_decision:'',
      approval_ref_number:'',
      approved_amount:'',
      salvage_action:'',
      datadetailpopup:false,
      tag_number:'',
      menu_171: false,
      incdent_date_search: null,
      isDatePickerIncidentDate: new Date(),
      aricle_id_search:'',
      incident_info_search:'',
      claimabe_damage_search:'',
      ins_id:[],
      item_details:[],
      require_doc:'',
      inspection_report_data:'',
      file_required:false,
      insu_claim_item:'',
      insu_claim_decision:null,
      salvage_item: [],
      salvage_action:null,
      salvage_value: '',
      updatepopinitem:false,
      item_label_name:'',
      data_type_upload:'',
      data_type_info:'',
      item_id:'',
      item_field_name:'',
      search:'',
      datadetailpopupdisposition: false,
      dataDetailPopupInClaimTicket: false,
      dataDetailPopupPendingDecision: false,
      rejectpopup:false,
      reject_disposition_lit:'',
      rejectdisposition:'',
      rejectsussesspopup: false,
      successmessage:'',
      updatemessage:'',
      currentUser: {},
      itemLength:'',
      disposition_item:'',
      selectedDisposition:'',
      approveconfirmpopup:false,
      updateAmountPopup:false,
      claim_amount:'',
      update_amount:'',
      tab_index: 0,
      isFilteringPage: false,
      filterPageNo : 1,
      putaway_process:'',
      is_short_item: false,
      isLoading: false,
      primary_code: "#0275d8",
      disabledClaimDecision : false,
      disabledRefernceNum : false,
      disabledApprovedAmt : false,
      disabledSalvageAction : false,
      disabledSalvageValue: false,
      disabledClaimTicketDate : false,
      disabledClaimTicketNum : false,
      disabledInspectionTicketDate : false,
      disabledInspectionReport : false,
      organization_name:'',
      role:'',
      benchmark_price: '',
      salvageFlag: false,
      approval_reference_text: '',
      insurance_approval_attachment:'',
      disabledAppRefText : false,
      map_value: '',
      putaway_filter:null,
      puttawayList:["Pending","Completed"],
      excess_amount:'',
      nstd_deduction:'',
      any_other_deduction:'',
      buyer_code:null,
      buyer_code_items:[],
      // exceedingZeroRule: v => (!v || parseInt(v) <= 0 ? 'Only numbers greater than 0 are allowed' : true)
      // mrp_rule: [ v => !!v || 'The field is required',
      //   v => (Number(v) <= Number(this.claim_amount)) || 'Approved amount should be less then claim amount' ],
      }
    },
    components: {
        HeaderComponent, Loading
      },
      validations: {
        file: {required }
      },
      async created() {
        this.role = this.$store.state.currentUser.roles[0]
        if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Insurance')){
          signout()
          return;
      }
      this.organization_name = this.$store.state.organization_name
      this.currentUser = this.$store.state.currentUser;
      this.action = this.$store.state.action;
      this.$store.state.action = '';
      const tab = this.$store.state.active_tab
      if(this.action || tab){
        if(this.action == 'Pending Information' || tab == 'Pending Information'){
          this.tab_index = 0;
          this.loadData('Pending Information')
        } else if(this.action == 'Pending Claim Ticket' || tab == 'Pending Claim Ticket'){
          this.tab_index = 1;
          this.loadData('Pending Claim Ticket')
        } else if(this.action == 'Pending Inspection' || tab == 'Pending Inspection'){
          this.tab_index = 2;
          this.loadData('Pending Inspection')
        } else if(this.action == 'Pending Decision' || tab == 'Pending Decision'){
          this.tab_index = 3;
          this.loadData('Pending Decision')
        }else if(this.action == 'Pending Disposition' || tab == 'Pending Disposition'){
          this.tab_index = 4;
          this.loadData('Pending Disposition')
        }else{
          this.tab_index = 0;
          this.loadData('Pending Information')
        }
      } else {
          this.tab_index = 0;
          this.loadData('Pending Information')
      }
    },
    watch: {    
      selected(newVal) {
        if(this.active_tab === 'Pending Information' || this.active_tab === 'Pending Claim Ticket'){
          const putawayInward = newVal.filter(item => !item.is_putaway_inwarded)
          const hasNonShortItem = newVal.some(item => { return !item.is_short_item && (this.active_tab === 'Pending Claim Ticket' || this.active_tab === 'Pending Information')});
          const isUnderPhysicalInspection = newVal.filter((insurances) => insurances.is_under_physical_inspection === true);
          if(putawayInward.length > 0 && hasNonShortItem){
            this.$nextTick(() => {
              this.showAlert("warning", "Please complete Putaway Process");
              this.selected = [];
              this.scrollToTop();
            });
          }else if(isUnderPhysicalInspection.length > 0){
            this.$nextTick(() => {
              this.showAlert("warning", "Action on item blocked as it is under cycle count process");
              this.selected = [];
              this.scrollToTop();
            });
          }
        }
      }
    },
    methods: {
      isActionAllowed(){
          return !isOnlyViewAction(this.role, 'Insurance')
        },
      changeSalvageAction(){
         this.salvage_value = null;
          if(this.$isRelianceClient() && this.salvage_action === 'Liquidate'){
            this.salvageFlag = true;
          }else {
            this.salvageFlag = false;
          }
        },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      onKeyPress(event,field,row) {
        const mobile_field = ['Mobile Number of Claim Logged','Site POC 1 Mobile','Site POC 2 Mobile']
        const email_field = ['Email ID of Claim Logged','Site POC 1 Email ID','Site POC 2 Email ID']
        const specialCharsRegex = mobile_field.includes(field) ? /[!@#$%^&*()_+\-=\[a-zA-Z\]{};':"\\|,.<>\/?]/ : email_field.includes(field) ? /[!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]/ :  /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (specialCharsRegex.test(event.key) || mobile_field.includes(field) && row && row.value.length > 9) {
          event.preventDefault();
        }
      },
      onKeyPressUpdate(event) {
          const allowedKeys = /[0-9,]/;
          if (!allowedKeys.test(event.key) || event.key === ' ' || event.key === '-' || event.key === '.') {
              event.preventDefault();
          }
      },
      addNewRow() {
        this.rows = [
          ...this.rows,
            {
              field: "",
              file: '',
              key:'',
              data_type:'',
              label:''
            }
          ];
      },
      getFilteredDocuments(currentRow) {
        const filteredItems = JSON.parse(JSON.stringify(this.pending_documents));
        this.rows.forEach((row) => {
          if (row !== currentRow && row.field) {
            const index = filteredItems.findIndex((item) => item.field === row.field);
            if (index !== -1) {
              filteredItems.splice(index, 1);
            }
          }
        });
        return filteredItems;
      },
      deleteRow(index) {
        this.rows.splice(index, 1);
      },
      getRequestParams(page, pageSize) {
        let params = {};

        if (page) {
          params["page"] = page;
        }
        if (pageSize) {
          params["size"] = pageSize;
        }
        return params;
      },
        showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
      changeInfo(row){
        this.isShow = false;
        this.pending_documents.forEach(item => {
          if(item.field == row.field){
            row.data_type = item.data_type
            row.label = item.label
            console.log(row.data_type + ' ' + row.label);
            
          }
        })
      },
      loadData(tab, tab_action) {
        if(tab_action){
          this.pending_info_search = ''
          this.select_field = null;
        }
        this.loading = true;
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.filterPageNo = 1
        this.isFilteringPage = false
        this.closeFilterpopup();
        this.$store.commit('setActiveTab',{
          'active_tab' : tab
        })
        if (tab == "Pending Information") {
          (this.headers = [
          { title: "Tag ID", key: "tag_number",minWidth:"200px", align: "start", sortable: false },
          { title: "Incident Location", key: "incident_location",minWidth:"200px"},
          { title: "Article ID", key: "sku_code",minWidth:"200px" },
          { title: "Article Description", key: "item_description",minWidth:"200px" },
          { title: "Incident Date", key: "incident_date",minWidth:"200px" },
          { title: "Damage Type", key: "damage_type",minWidth:"200px" },
          { title: "Responsible Vendor", key: "responsible_vendor",minWidth:"200px" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Sub-Location", key:"sub_location_name"},         
          ]);

          this.fetchPendingInfromation();
        }
        if (tab == 'Pending Claim Ticket') {
          (this.headers = [
          { title: "Tag ID", key: "tag_number",minWidth:"200px", align: "start", sortable: false },
          { title: "Incident Location", key: "incident_location", minWidth:"200px" },
          { title: "Article ID", key: "sku_code", minWidth:"200px" },
          { title: "Claim Amount (₹)", key: "claim_amount", minWidth:"200px" },
          { title: "Article Description", key: "item_description", minWidth:"200px" },
          { title: "Incident Date", key: "incident_date", minWidth:"200px" },
          { title: "Damage Type", key: "damage_type", minWidth:"200px" },
          { title: "Sub-Location", key:"sub_location_name"},
          { title: "Ageing", key:"disposition_age"},
          { title: "Action", key: "action", minWidth:"200px" },
         
          ]);

          this.fetchPendingClaimTicket();
        }
        if (tab == 'Pending Inspection') {
          (this.headers = [
          { title: "Tag ID", key: "tag_number",minWidth:"200px", align: "start", sortable: false },
          { title: "Article ID", key: "sku_code",minWidth:"200px" },
          { title: "Article Description", key: "item_description",minWidth:"200px" },
          { title: "Claim Amount (₹)", key: "claim_amount",minWidth:"200px" },        
          { title: "Insurance Ticket No.", key: "claim_ticket_number",minWidth:"200px" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Sub-Location", key:"sub_location_name"}
          ]);

          this.fetchPendingInspection();
        }
        if ((tab == 'Pending Disposition')) {
          this.selectedDisposition = '';
          (this.headers = [
          { title: "Tag ID", key: "tag_number",minWidth:"200px", align: "start", sortable: false },
          { title: "Article ID", key: "sku_code",minWidth:"200px" },
          { title: "Article Description", key: "item_description",minWidth:"200px" },
          { title: "Grade", key: "grade",minWidth:"200px" },       
          { title: "Benchmark Price (₹)", key: "benchmark_price",minWidth:"200px" },        
          { title: "Net Recovery (₹)", key: "net_recovery" },
          { title: "Net Recovery (%)", key: "recovery_percent",minWidth:"200px" },
          { title: "Remarks", key:"remarks"},
          { title: "Ageing", key:"disposition_age"},
          { title: "Sub-Location", key:"sub_location_name"}
          ]);
          this.fetchPendingDisposition();

          this.$httpSecured
          .get("/api/v1/warehouse/new_insurances/get_dispositions")
          .then(response => {
            if (response.data) {
              this.disposition_item = response.data.dispositions;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }
        if (((tab == 'Pending Disposition') && (this.currentUser.roles.includes('central_admin'))) || ((tab == 'Pending Disposition') && (this.currentUser.roles.includes('admin')))) {
          this.selectedDisposition = '';
          (this.headers = [
          { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false },
          { title: "Article ID", key: "sku_code" },
          { title: "Article Description", key: "item_description" },
          { title: "Grade", key: "grade" },
          { title: "Assigned Disposition", key: "assigned_disposition" },   
          { title: "Net Recovery (%)", key: "recovery_percent" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Sub-Location", key:"sub_location_name"}
        
          ]);
          this.fetchPendingDisposition();

          this.$httpSecured
          .get("/api/v1/warehouse/new_insurances/get_dispositions")
          .then(response => {
            if (response.data) {
              this.disposition_item = response.data.dispositions;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }

        if (tab == 'Pending Decision') {
          (this.headers = [
          { title: "Tag ID", key: "tag_number", width: '12%', align: "start", sortable: false },
          { title: "Article ID", key: "sku_code" },
          { title: "Article Description", key: "item_description" },
          { title: "Claim Amount (₹)", key: "claim_amount" },        
          { title: "Insurance Ticket No.", key: "claim_ticket_number" },
          { title: "Ageing", key:"disposition_age"},
          { title: "Sub-Location", key:"sub_location_name"}
          ]);
          this.fetchPendingDecision();
        }
        if (tab == 'Pending For Approval') {
          this.headers = [
                    { title: "Location", key: "location"},
                    { title: "IRD", key: "ird" },
                    { title: "Tag ID", key: "tag_number" },
                    { title: "Article ID", key: "article_id" },
                    { title: "Article Description", key: "article_description"},
                    { title: "Lot ID", key: "lot_id" },
                    { title: "Publish ID", key: "publish_id"},
                    { title: "Recovery Benchmark Price", key: "recovery_benchmark_price" },
                    { title: "Serial No.1", key: "serial_number" },
                    { title: "Serial No.2", key: "serial_number2"},
                    { title: "Approval Type", key: "approval_rule_type"},
                    { title: "Pending At", key: "next_approver_details"}
                ];
          this.select_field_items = [
             {
                "name":"Tag ID",
                "id": "tag_number"
              },
              {
                "name":"IRD",
                "id": "ird_number"
              },
              {
                "name":"Lot ID",
                "id": "lot_id"
              },
              {
                "name":"Publish ID",
                "id": "publish_id"
              },
              {
                "name":"Pending at",
                "id": "pending_at"
              }
              ];
          this.fetchPendingForApproval();
        }  
        const secondLastIndex = this.headers.length - 1;   
        if(this.$isRelianceClient() && tab != 'Pending For Approval')
        this.headers.splice(secondLastIndex, 0, 
          { title: "IRRD Number", key: "irrd"},
          { title: "IRD Number", key:"ird"}, 
          { title: "Item Serial Number", key: "serial_number" });
      },
      fetchPendingInfromation() {
        this.loading = true;
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.pending_info_search){
            params[this.select_field.id] = this.pending_info_search.trim()
        }
        this.$httpSecured
        .get("/api/v1/warehouse/new_insurances/index_new?status=pending_information", { params: {page: params['page'], per_page: params['size'],...params } })
        .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingClaimTicket() {
        this.loading = true;
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.pending_info_search){
            params[this.select_field.id] = this.pending_info_search.trim()
        }
        this.$httpSecured
        .get("/api/v1/warehouse/new_insurances/index_new?status=pending_claim_ticket", { params: {page: params['page'], per_page: params['size'],...params } })
        .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingInspection() {
        this.loading = true;
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.pending_info_search){
            params[this.select_field.id] = this.pending_info_search.trim()
        }
        this.$httpSecured
        .get("/api/v1/warehouse/new_insurances/index_new?status=pending_inspection", { params: {page: params['page'], per_page: params['size'],...params } })
        .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingDecision() {
        this.loading = true;
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.pending_info_search){
            params[this.select_field.id] = this.pending_info_search.trim()
        }
        this.$httpSecured
        .get("/api/v1/warehouse/new_insurances/index_new?status=pending_decision", { params: {page: params['page'], per_page: params['size'],...params } })
        .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingForApproval() {
        this.loading = true;
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.pending_info_search){
            params[this.select_field.id] = this.pending_info_search.trim()
        }
        this.$httpSecured
        .get("/api/v1/warehouse/new_insurances/index_new?status=pending_approval", { params: {page: params['page'], per_page: params['size'],...params } })
        .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      fetchPendingDisposition() {
        this.loading = true;
        const params = this.getRequestParams(
          this.page,
          this.pageSize
        );
        if(this.pending_info_search){
            params[this.select_field.id] = this.pending_info_search.trim()
        }
        this.$httpSecured
        .get("/api/v1/warehouse/new_insurances/index_new?status=pending_disposition", { params: {page: params['page'], per_page: params['size'],...params } })
        .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      handlePageChange(value) {
        this.page = value;
        if(this.isFilteringPage){
              this.filterPageNo = value;
              this.applyFilterFunc()
            }else{
              if (this.active_tab == 'Pending Information') {
              this.fetchPendingInfromation();
            }else if(this.active_tab == 'Pending Claim Ticket'){
              this.fetchPendingClaimTicket();
            }else if(this.active_tab == 'Pending Inspection'){
              this.fetchPendingInspection();
            }else if(this.active_tab == 'Pending Decision'){
              this.fetchPendingDecision();
            }else if(this.active_tab == 'Pending For Approval'){
              this.fetchPendingForApproval();
            }else{
              this.fetchPendingDisposition();
            }
            }  
      },
      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        this.filterPageNo = 1;
        if(this.isFilteringPage){
            this.applyFilterFunc();
          }else{
            if (this.active_tab == 'Pending Information') {
            this.fetchPendingInfromation();
          }else if(this.active_tab == 'Pending Claim Ticket'){
            this.fetchPendingClaimTicket();
          }else if(this.active_tab == 'Pending Inspection'){
            this.fetchPendingInspection();
          } else if(this.actions == 'Pending Decision'){
            this.fetchPendingDecision();
          }else if(this.active_tab == 'Pending For Approval'){
              this.fetchPendingForApproval();
          }else{
            this.fetchPendingDisposition();
          }
        }     
      },
      updatedialog(){
        // if(this.selected.some(item => { return !item.is_short_item && !item.is_putaway_inwarded })){
        //   this.$toast.error("Please complete Putaway Process");
        //   this.scrollToTop();
        //   this.selected = []
        //   return;
        // }
        this.UpdatePopup = true;
        this.number = 0;
        this.isShow = true;
        this.rows = [];
        this.addNewRow();
        this.ins_id = this.selected.map(insurances => insurances.id);
        this.$httpSecured
          .get("/api/v1/warehouse/new_insurances/get_pending_documents", { params: { ids:this.ins_id } })
          .then(response => {
            if (response.data) {
              this.pending_documents = response.data.pending_documents;
              this.pending_doc = response.data.pending_documents;
              this.data_type_upload = 
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      filterListOfButtons(ev) {
        this.filterCategory= [],
        this.filterGrade = [],
        this.filterBrand = [],
        this.filterStatus = '',
        this.filterRequestType = '',
        this.putaway_search = ''
        this.pending_info_search = ''
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
        this.filteWithSubPopup = true;
      },
      updatedialogPCT(){
        this.claim_ticket_date = '';
        this.isDatePickerInspectionDate = null;
        this.claim_ticket_number = '';
        this.inspection_date = '';
        this.isDatePickerClaimTicketDate = null;
        this.file = '';
        if(this.active_tab == 'Pending Claim Ticket'){
          this.checkClaimTicketUpdateDis();
          this.ins_id = this.selected.map(insurances => insurances.id);
          var selected = this.selected.filter(x => x.claim_amount == null)
          if(selected.length > 0){
            this.showAlert("warning", 'Please Select only updated amount only')
          this.selected = [];
          return
          }
          this.updatePopupPendingClaimTicket = true;
          this.number=0;
          this.claim_ticket_date = this.selected.length == 1 && this.selected[0].claim_ticket_date && this.selected[0].claim_ticket_date != 'N/A' ? this.selected[0].claim_ticket_date.split('/').reverse().join('/') : '';
          this.claim_ticket_number = this.selected.length == 1 && this.selected[0].claim_ticket_number && this.selected[0].claim_ticket_number != 'N/A' ? this.selected[0].claim_ticket_number : '';
        }
        if(this.active_tab == 'Pending Inspection'){
          this.checkInspectionUpdateDis();
          this.ins_id = this.selected.map(insurances => insurances.id);
          this.updatePopupPendingInspection = true;
          this.number=0;
          this.inspection_date = this.selected.length == 1 && this.selected[0].inspection_date && this.selected[0].inspection_date != 'N/A' ? this.selected[0].inspection_date.split('/').reverse().join('/') : '';
          this.file = '';
          if(this.selected.length == 1 && this.selected[0].inspection_report && this.selected[0].inspection_report != 'N/A'){
            const parts = this.selected[0].inspection_report.split('/').reverse()
            this.file = {}
            this.file.name = parts[0]
          }
        }
        if(this.active_tab == 'Pending Decision'){
          this.checkPendingDecision();
          this.ins_id = this.selected.map(insurances => insurances.id);
          var inventory_ids  = []
          for (var i = 0; i < this.selected.length; i++) {inventory_ids.push(this.selected[i].id)}
          inventory_ids = inventory_ids.map((id) => id.toString());
          var idsString = inventory_ids.join(','); 
          if(this.selected.length == 1){
            this.has_multiple_items = false
            this.insu_claim_decision = this.selected[0].claim_decision ? this.selected[0].claim_decision : null
            this.approval_ref_number = this.selected[0].approval_ref_number ? this.selected[0].approval_ref_number : ''
            this.approved_amount = this.selected[0].approved_amount ? this.selected[0].approved_amount : ''
            this.salvage_action = this.selected[0].salvage_action ? this.selected[0].salvage_action : null
            this.salvage_value = this.selected[0].salvage_value ? this.selected[0].salvage_value : ''
            this.approval_reference_text = this.selected[0].approval_reference_text ? this.selected[0].approval_reference_text : ''
            this.insurance_approval_attachment = null
          }else{
            this.has_multiple_items = true
          }

          if((this.selected[0].tag_number.includes('SI') || this.selected[0].tag_number.includes('si')) && this.$isRelianceClient()){
            this.salvage_action = 'No Action'
            this.disabledSalvageAction = true
          }
          
          this.updatePopupPendingDecision = true;
          this.getBuyerCodeList();
          this.number=0;
          this.$httpSecured
          .get("api/v1/warehouse/new_insurances/get_claim_decisions",{ params: { has_multiple_items: this.has_multiple_items, ids: idsString } })
          .then(response => {
            if (response.data) {
              this.insu_claim_item = response.data.claim_decisions;
              this.salvage_item = response.data.salvage_actions;
              this.claim_amount = response.data.approved_amount;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });

        }      
      },
      getBuyerCodeList() {
        this.$httpSecured
        .get("/api/v2/warehouse/liquidation/contracted_price/get_vendor_contract")
        .then(response => {
            if (response.data) {
              this.buyer_code_items = response.data.buyers
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
          });
      },
      downloadInventory() {
        this.down_ids = this.selected.map(bcl => bcl.id);
        let tab_name
        if(this.active_tab === 'Pending Information'){
          tab_name = 'pending_information'
        }else if(this.active_tab === 'Pending Claim Ticket'){
          tab_name = 'pending_claim_ticket'
        }else if(this.active_tab === 'Pending Inspection'){
          tab_name = 'pending_inspection'
        }else{
          tab_name = 'pending_decision'
        }
        this.$httpSecured.post("/api/v1/warehouse/new_insurances/get_csv_file",
        {
          "ids": this.down_ids,
          "status": tab_name
        })
          .then(response => {
            this.rejectsussesspopup = true
            if(response.data.url){
              const link = document.createElement('a');
              link.href=response.data.url
              link.click()
              this.successmessage = "File downloaded successfully!"
            } else 
              this.successmessage = response.data.message
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      navigateToFileUpload(){
        this.$store.commit("setLotIds", {
              lotIds: 'insurance_operations',
              action:this.active_tab,
              inventoryId: 'Insurance'
            });
            this.$store.commit("config/ADD_HEADER", this.headerText);
           this.$router.push({ name: 'LotFileuploadComm' });
      },
      itemDetailpopup(item){
        this.putaway_process = item.is_putaway_inwarded
        this.is_short_item = item.is_short_item
        if(this.active_tab == 'Pending Disposition'){
          this.datadetailpopupdisposition = true
          this.tag_number = item.tag_number;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
          .get(`api/v1/warehouse/new_insurances/${this.item_id}`)
          .then(response => {
            if (response.data) {
              this.item_details = response.data.insurance
              this.require_doc = response.data.insurance.required_documents
              this.inspection_report_data = response.data.insurance.inspection_report;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }else if(this.active_tab == 'Pending Information'){
          this.datadetailpopup = true;
          this.tag_number = item.tag_number;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
          .get(`api/v1/warehouse/new_insurances/${this.item_id}`)
          .then(response => {
            if (response.data) {
              this.item_details = response.data.insurance
              this.require_doc = response.data.insurance.required_documents
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }else if(this.active_tab == 'Pending Decision'){
            this.dataDetailPopupPendingDecision = true;
            this.tag_number = item.tag_number;
            let str = String(this.tag_number);
            this.tag_number = str;
            this.item_id = item.id;
            this.$httpSecured
          .get(`api/v1/warehouse/new_insurances/${this.item_id}`)
          .then(response => {
            if (response.data) {
              this.item_details = response.data.insurance
              this.require_doc = response.data.insurance.required_documents
              this.inspection_report_data = response.data.insurance.inspection_report;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });        
        }else if(this.active_tab == 'Pending Claim Ticket' || this.active_tab == 'Pending Inspection'){
          this.dataDetailPopupInClaimTicket = true;
          this.tag_number = item.tag_number;
          let str = String(this.tag_number);
          this.tag_number = str;
          this.item_id = item.id;
          this.$httpSecured
          .get(`api/v1/warehouse/new_insurances/${this.item_id}`)
          .then(response => {
            if (response.data) {
              this.item_details = response.data.insurance
              this.require_doc = response.data.insurance.required_documents
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }
      
      },
      applyFilterFunc() {
        this.isFilteringPage = true
        const params = new URLSearchParams();
        if(this.incident_info_search)
          params.append('incident_location', this.incident_info_search);
        if(this.incdent_date_search)
          params.append('incident_date', this.formatted_filter_date(this.incdent_date_search));
        if(this.claimabe_damage_search) 
          params.append('damage_type', this.claimabe_damage_search);
        if(this.aricle_id_search)
          params.append('sku_code', this.aricle_id_search);
        if(this.putaway_filter)
          params.append('putaway', this.putaway_filter);
        params.append('page' , this.filterPageNo)
        params.append('per_page' , this.pageSize)

        if(this.active_tab  == "Pending Information"){
          this.$httpSecured
          .get('/api/v1/warehouse/new_insurances?status=pending_information', { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.filteWithSubPopup=false;
              // this.aricle_id_search = '';
              // this.incident_info_search = '';
              // this.incdent_date_search = '';
              // this.claimabe_damage_search = '';
              this.menu_171 = false
              this.loading = false;
              this.selected = [];
              // this.closeFilterpopup();

            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }
        if(this.active_tab  == "Pending Claim Ticket"){
          this.$httpSecured
          .get('/api/v1/warehouse/new_insurances?status=pending_claim_ticket', { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.filteWithSubPopup=false;
              this.loading = false;
              this.selected = [];
              // this.closeFilterpopup();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }
        if(this.active_tab  == "Pending Inspection"){
          this.$httpSecured
          .get('/api/v1/warehouse/new_insurances?status=pending_inspection', { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.filteWithSubPopup=false;
              this.loading = false;
              this.selected = [];
              // this.closeFilterpopup();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }
        if(this.active_tab  == "Pending Decision"){
          this.$httpSecured
          .get('/api/v1/warehouse/new_insurances?status=pending_decision', { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.filteWithSubPopup=false;
              this.loading = false;
              this.selected = [];
              // this.closeFilterpopup();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }
        if(this.active_tab  == "Pending Disposition"){
          this.$httpSecured
          .get('/api/v1/warehouse/new_insurances?status=pending_disposition', { params })
          .then(response => {
            if (response.data) {
              this.table_data = response.data.insurances
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count
              this.filteWithSubPopup=false;
              this.loading = false;
              this.selected = [];
              // this.closeFilterpopup();
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        }
      
      },
      closeFilterpopup(){
        this.filteWithSubPopup = false;
        this.aricle_id_search = '';
        this.incident_info_search = '';
        this.incdent_date_search = '';
        this.claimabe_damage_search = '';
        this.putaway_filter = null;
      },
      updatePendingClaimSubmit() {
        this.number++;
        const formData = new FormData();
        this.$httpSecured.put("/api/v1/warehouse/new_insurances/update_claim_ticket", {
          "ids": this.ins_id,
          "claim_ticket_date": this.formatted_filter_date(this.claim_ticket_date),
          "claim_ticket_number": this.claim_ticket_number
        },)
          .then(response => {
            if (response.data) {
              this.updatePopupPendingClaimTicket = false
              this.successmessage = response.data.message;
              this.updatemessage = 'Pending Inspection'
              this.rejectsussesspopup = true;
              this.itemLength = this.selected.length;
              this.showAlert("success", "Successfully updated");
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
            this.number = 0;

          });
      },
      updatePendingInspectionSubmit() {
      this.number++;
        
        if (this.file) {
          const allowedFileTypes = ['.pdf', '.png', '.eml'];
          const fileType = this.file.name.substring(this.file.name.lastIndexOf('.')).toLowerCase();
          if (!allowedFileTypes.includes(fileType)) {
            this.showAlert("error",'Invalid file type. Only PDF, PNG, and EML files are allowed.');
            return;
          }
        }
        
        this.ins_id = Array.from(this.selected.map(insurances => insurances.id));
        const formData = new FormData();
        formData.append('claim_inspection_date', this.formatted_filter_date(this.inspection_date));
        formData.append('inspection_report', this.file);
        formData.append('ids', this.ins_id);
        this.$httpSecured.put("/api/v1/warehouse/new_insurances/update_inspection_details", formData, {
          headers: {
          'Content-Type': 'multipart/form-data'
              }
          }     
        )
          .then(response => {
            if (response.data) {
              this.updatePopupPendingInspection = false
              this.successmessage = response.data.message;
              this.rejectsussesspopup = true;
              this.inspection_date = new Date();
              this.file = '';
              this.updatemessage = 'Pending Decision'
              this.rejectsussesspopup = true;
              this.itemLength = this.selected.length;
              this.showAlert("success", "Successfully updated");
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error ? error.response.data.error : error.response.data.message);
            this.loading = false;
            this.number = 0;
          });
      },
      updatePendingDecisionSubmit() {
        this.number++;
        if (this.file) {
        const allowedFileTypes = ['.pdf', '.png', '.eml'];
        const fileType = this.file.name.substring(this.file.name.lastIndexOf('.')).toLowerCase();
        if (!allowedFileTypes.includes(fileType)) {
          this.showAlert("error",'Invalid file type. Only PDF, PNG, and EML files are allowed.');
          return;
        }
        }

        const formData = new FormData();
        formData.append('ids', this.ins_id);
        formData.append('claim_decision', this.insu_claim_decision);
        formData.append('approval_ref_number', this.approval_ref_number);
        formData.append('approved_amount', this.approved_amount);
        formData.append('salvage_action', this.salvage_action);
        formData.append('salvage_value', this.salvage_value);
        formData.append('insurance_approval_attachment', this.insurance_approval_attachment)
        formData.append('approval_reference_text', this.approval_reference_text)
        formData.append('excess', this.excess_amount);
        formData.append('non_standard_deduction', this.nstd_deduction);
        formData.append('any_other_deduction', this.any_other_deduction);
        if(this.salvage_action === 'Liquidate'){
          formData.append('remarketing_buyer_id', this.buyer_code ? this.buyer_code : '');
        }
        this.$httpSecured.put("/api/v1/warehouse/new_insurances/update_approval_details",formData, {
          headers: {
          'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => {
            if (response.data) {
              this.updatePopupPendingDecision = false
              this.successmessage = response.data.message;
              this.salvage_action = null;
              this.salvageFlag = false;
              this.salvage_value = '';
              this.approved_amount = '';
              this.approval_ref_number = '';
              this.insu_claim_decision = null;
              this.insurance_approval_attachment = null;
              this.approval_reference_text = ''
              this.nstd_deduction = '';
              this.any_other_deduction = '';
              this.excess_amount = '';
              this.salvage_value = '';
              this.buyer_code = null;
              this.updatemessage = 'Pending Disposition'
              this.rejectsussesspopup = true;
              this.itemLength = this.selected.length;
              this.showAlert("success", "Successfully updated");
              this.number = 0;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
            this.number = 0;
          });
      },

      handleFileChange(event) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          // this.file = file;
        };
        reader.readAsBinaryString(file);
      },
      selectFile(event){
        this.file = event.target.files[0]
        const reader = new FileReader()
        reader.readAsBinaryString(this.file)
        reader.onload = () => {
          this.binaryData = btoa(reader.result)
        }
        },
        closePopup(){
          this.updatePopupPendingDecision = false;
          this.salvage_action = '';
          this.salvageFlag = false;
          this.approved_amount = '';
          this.approval_ref_number = '';
          this.insu_claim_decision = '';
          this.insurance_approval_attachment = null;
          this.approval_reference_text = ''
          this.updateAmountPopup = false;
          this.update_amount = '';
          this.nstd_deduction = '';
          this.any_other_deduction = '';
          this.excess_amount = '';
          this.salvage_value = '';
          this.buyer_code = null;
        },

        updateItemPopup(doc){
          this.isDatePickerClaimTicketDate= null;
          if(this.putaway_process === false && this.is_short_item == false){
            this.$toast.error("Please complete Putaway Process");
            this.scrollToTop();
          }else{
            this.updatepopinitem = true;
            this.number = 0;
            this.item_label_name = doc.label;
            this.item_field_name = doc.field;
            this.data_type_upload = doc.data_type;
          }
        },
        closeItempopup(){
          this.updatepopinitem = false;
          this.file = '';
          this.item_label_name = '';
          this.data_type_info = '';
        },
        updateInfoDocItemSubmit() {
          if(this.data_type_upload == 'date' && this.validateDate(this.data_type_info) === 'Date cannot be in the future'){
            this.$toast.error("Please select past date only!")
            return;
          }
          this.number++;
      
        const formData = new FormData();
        formData.append('field', this.item_field_name );
        formData.append('label', this.item_label_name);
        formData.append('data_type', this.data_type_upload);
        formData.append('file', this.file[0]);
        formData.append('value', this.data_type_info);

        this.$httpSecured.put(`/api/v1/warehouse/new_insurances/${this.item_id}/update_document`,  formData, {
          headers: {
          'Content-Type': 'multipart/form-data'
              }
          } )
          .then(response => {
            if (response.data) {
              this.updatepopinitem = false
              this.datadetailpopup = false;
              this.data_type_info ='';
              this.file = '';
              this.selected = []
              if(response.data.message === 'Data updated successfully.Item current status is Pending Claim Ticket'){
                 this.showAlert("success", "1 item moved to Pending Claim Ticket");
              }else{
                this.showAlert("success", "Data updated successfully");
              }
              
              this.number=0;
              this.loadData(this.active_tab);
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;

          });
      },
      selectPendingDoc(dataType, index){
        let docu=this.pending_doc.filter(obj =>  obj.field==dataType)
        this.infoDataType = docu[0].data_type;
      },
      getAcceptType(dataType, index) {
        this.isShow = false;     
        let docu=this.pending_documents.filter(obj =>  obj.field==dataType)    
        const fileType = this.fileTypeMapping[docu[0].data_type];
        this.rows[index].data_type = docu[0].data_type; 
        // this.infoDataType[index]  = this.rows[index].data_type   
        this.rows[index].label = docu[0].label;
        return fileType ? fileType : '';
    
    },

    handleFileChangeUpdate(event, index) {
      this.rows[index].file = event;
    },
    bulkUpdateDocSubmit() {
      this.number++;
      const hasFutureDate = this.rows.some(item => {
            return item.data_type === 'date' && this.validateDate(item.value) === 'Date cannot be in the future';
          });
          if(hasFutureDate){
            this.$toast.error("Please select past date only!")
            this.number = 0
            return;
          }
      const formData = new FormData();
      // const rowsJson = JSON.stringify(this.rows);
      // formData.append('documents', this.rows);
      formData.append('ids', this.ins_id );
      for (let i = 0; i < this.rows.length; i++) {
        this.rows[i].file ? formData.append(`file[${i}]`, this.rows[i].file) : formData.append(`file[${i}]`, '');
        formData.append(`field[${i}]`, this.rows[i].field);
        formData.append(`label[${i}]`, this.rows[i].label);
        formData.append(`data_type[${i}]`, this.rows[i].data_type);
        formData.append(`value[${i}]`, this.rows[i].value);
      }
      this.$httpSecured.post('/api/v1/warehouse/new_insurances/bulk_update_docs', formData, {
        headers: {
        'Content-Type': 'multipart/form-data'
            }
        }
          )
        .then(response => {
          if (response.data) {
            this.UpdatePopup = false
            this.successmessage = response.data.message;
            // this.rows=[];
            this.updatemessage = 'Pending Claim Ticket'
            this.rejectsussesspopup = true;
            this.itemLength = this.selected.length;
            this.showAlert("success", response.data.message);
            this.number = 0;
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        }).catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
          this.loading = false;

        });
    },
      approveConfirmPopup(){
        this.approveconfirmpopup = true;
      },
      adminApproveItem() {
          this.number++;
          this.ins_id = this.selected.map(insurances => insurances.id);
        this.$httpSecured.post('/api/v1/warehouse/new_insurances/set_disposition', {
          "ids":this.ins_id
        },)
          .then(response => {
            if (response.data) {
              this.approveconfirmpopup = false
              this.successmessage = response.data.message;
              this.rejectsussesspopup = true;
              this.showAlert("success", "Successfully updated");
              this.loadData(this.active_tab);
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;

          });
      },
      rejectDialog(){
        this.rejectpopup = true;
        this.$httpSecured
          .get("/api/v1/warehouse/new_insurances/get_dispositions")
          .then(response => {
            if (response.data) {
              this.reject_disposition_lit = response.data.dispositions;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      adminRejectItem() {
          this.number++;
          this.ins_id = this.selected.map(insurances => insurances.id);
        this.$httpSecured.post('/api/v1/warehouse/new_insurances/set_disposition', {
          "ids":this.ins_id,
          "disposition_action": "reject",
          "disposition": this.rejectdisposition
        },)
          .then(response => {
            if (response.data) {
              this.rejectpopup = false;
              this.successmessage = response.data.message;
              this.rejectsussesspopup = true;
              this.loadData(this.active_tab);
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;

          });
      },
      rejectColsePopup(){
        this.rejectpopup = false;
        this.rejectdisposition = '';
      },
      afterClickOkLoadData(){
        this.rejectsussesspopup = false;
        this.selectedDisposition = '';
        this.selected=[];
        this.loadData(this.active_tab);
      },
      assignDisposition(selectedDisposition){
        this.isLoading = true
        this.ins_id = this.selected.map(insurances => insurances.id);
        this.$httpSecured.post('/api/v1/warehouse/new_insurances/update_disposition', {
          "ids":this.ins_id,
          "disposition": selectedDisposition
        },)
          .then(response => {
            if (response.data) {
              this.successmessage = response.data.message;
              this.rejectsussesspopup = true;
              // this.selectedDisposition = '';
              this.isLoading = false
            } else {
              this.showAlert("error", "No Data Found");
              this.isLoading = false
            }
          }).catch(error => {
            this.showAlert("warning", "Please select the insurance ids");
            this.selectedDisposition = '';
            this.loading = false;
            this.isLoading = false;
          });
      },
      updateAmount(item){
        this.updateAmountPopup = true;
        this.item_id = item.id
        this.update_amount =''; 
        this.positiveNumberRule = null;
      },
      updateAmountSubmit(){     
        this.$httpSecured.put(`/api/v1/warehouse/new_insurances/${this.item_id}/update_claim_amount`, {
          "claim_amount": this.update_amount
          } )
          .then(response => {
            if (response.data) {
              this.updateAmountPopup = false
              this.update_amount ='';          
              this.showAlert("success", "Successfully updated");
              this.loadData(this.active_tab);
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
            this.number = 0;
            this.loading = false;

          });
      },
      // changeDisposition(item){
      //   alert("hi1")
      //   if(this.insu_claim_decision === 'approved'){
      //     this.claim_amount = this.selected.map(insurances => insurances.claim_amount);
      //     this.approved_amount = this.claim_amount;
      //   }else if(this.insu_claim_decision == 'partially_approved'){
      //     this.approved_amount = ''
      //   }else{
      //     this.approved_amount = '0'
      //   }
      // },
      changeDisposition(item){
        if(this.insu_claim_decision == 'approved'){
          this.disabledApprovedAmt = false;
          this.disableApproveAmount = true;
          this.salvage_action = '';
          this.approval_ref_number = '';
          this.nstd_deduction = '';
          this.any_other_deduction = '';
          this.excess_amount = '';
          this.salvage_value = '';
          this.buyer_code = null;
          this.salvageFlag = true;
          this.disabledSalvageAction = true;
          this.approved_amount = '';
          if(this.selected[0].tag_number.includes('SI') || this.selected[0].tag_number.includes('si')){
            this.salvageFlag = false;
            this.salvage_action = 'No Action'
          }
        }else if(this.insu_claim_decision == 'partially_approved'){
          this.disabledApprovedAmt = false;
          this.disableApproveAmount = false;
          this.salvage_action = 'Liquidate'
          this.salvageFlag = true;
          this.disabledSalvageAction = true;
          this.salvage_action = '';
          this.approval_ref_number = '';
          this.nstd_deduction = '';
          this.any_other_deduction = '';
          this.excess_amount = '';
          this.salvage_value = '';
          this.buyer_code = null;
          this.approved_amount = ''
          if(this.selected[0].tag_number.includes('SI') || this.selected[0].tag_number.includes('si')){
            this.salvageFlag = false;
            this.salvage_action = 'No Action'
          }
        }else if(this.insu_claim_decision == 'rejected'){
           this.approved_amount = '0'
          this.salvage_action = '';
          this.approval_ref_number = '';
          this.nstd_deduction = '';
          this.any_other_deduction = '';
          this.excess_amount = '';
          this.salvage_value = '';
          this.buyer_code = null;
         
          this.disabledApprovedAmt = true;
        }else {
          this.disableApproveAmount = true;
          this.approved_amount = 0;
          this.salvage_action = '';
          this.salvageFlag = false;
          this.disabledSalvageAction = false;
        }
      },
      positiveNumberRule(value) {
        value = this.formatNumber(value);
        if (!value) {
          return 'Input is required';
        }
        if (value <= 0 || isNaN(value)) {
          return 'Input must be a positive number';
        }
        return true;
      },
      checkDisabilityAddMore(){
        const row = this.rows[this.rows.length-1];
        return !row || !row.field || (!row.value && !row.file) || (this.getFilteredDocuments(row).length == 1);
      },
      checkSubmitDisability(){
        const row = this.rows[this.rows.length-1];
        return !row.field || (!row.value && !row.file);
      },
      validatePositiveNumber(value) {
        const numberValue = parseFloat(value);
        if (!isNaN(numberValue) && numberValue >= 0) {
          return true;
        } else {
          this.approved_amount = '';
          return 'Please enter a positive value';
        }
      },
      formatNumber(value){
        return typeof value === 'string' ? Number(value.replace(/,/g, '')) : value
      },
      salvage_rule(value){
        let value1 = this.formatNumber(value)
        if(!value1 && value1 !== 0){
          return 'The field is required';
        } 
        if(this.$isRelianceClient()){
          let cleanApprovedAmount = parseFloat(String(this.approved_amount).replace(/,/g, ''));
          let mapValue = Number(this.selected[0].map) - cleanApprovedAmount - Number(this.selected[0].debit_amount);
          this.map_value = mapValue;
          let map = this.formatNumber(this.map_value);
          if(value < map){
            return `Salvage value should be more than ${this.map_value}`
          }
          if(value > this.selected[0].map){
            return 'Salvage value should be less than MAP'
          }
        }else{
          this.benchmark_price = this.selected[0].benchmark_price
          let benchmark = this.formatNumber(this.benchmark_price)
          if(value >= benchmark){
            return 'Salvage value should be less than benchmark price'
          }
        }
      },
      mrp_rule(value){
        let value1 = this.formatNumber(value)
        let amount = this.formatNumber(this.claim_amount)
        if(!value1 && value1 !== 0){
          return 'The field is required';
        }
        // if(value1 >= amount && this.insu_claim_decision == 'partially_approved'){
        //   return 'Approved amount should be less then claim amount'
        // }
        // if(value1 != amount && this.insu_claim_decision == 'approved'){
        //   return 'Approved amount should be equal to claim amount'
        // }             
        // if(value1 != 0 && this.insu_claim_decision == 'rejected'){
        //   return 'Approved amount should be equal to 0'
        // }       
      },
      insu_claim_decision_rule(value){
        if(this.selected.length == 1 && this.selected[0].claim_amount == this.formatNumber(this.approved_amount) && value != 'approved')
          return 'Insurance Claim Decision should be Approved';
        if(this.selected.length == 1 && this.selected[0].claim_amount > this.formatNumber(this.approved_amount)  && this.formatNumber(this.approved_amount) != 0 && value != 'partially_approved')
          return 'Insurance Claim Decision should be Partially Approved';
        // if(this.selected.length == 1 && this.formatNumber(this.approved_amount) == 0 && value != 'rejected')
        //   return 'Insurance Claim Decision should be Rejected';
      },
      handleSaveDate(dateType , dateState, selectDateState){
        this[dateState] = this.formatted_filter_date(this[selectDateState])
        this[dateType] = false
      },
      handleSaveDateByRow(dateState, selectDateState){
        dateState['value'] = this.formatted_filter_date(this[selectDateState])
        dateState['formatted_date'] = dateState['value'].split('-').reverse().join('/')
        dateState['menu_14'] = false
      },
      checkPendingDecision(){
        this.disabledClaimDecision = false
        this.disabledRefernceNum = false,
        this.disabledApprovedAmt = false,
        this.disabledSalvageAction = false,
        this.disabledAppRefText = false,
        this.selected.forEach(item => {
          if(item.claim_decision) this.disabledClaimDecision = 1;
          if(item.approval_ref_number) this.disabledRefernceNum = 1;
          if(item.approval_reference_text) this.disabledAppRefText = 1
          if(item.approved_amount) this.disabledApprovedAmt = 1;
          if(item.salvage_action) this.disabledSalvageAction = 1;
        })
        return this.disabledClaimDecision && this.disabledRefernceNum && this.disabledApprovedAmt && this.disabledSalvageAction;
      },
      checkClaimTicketUpdateDis(){
        this.disabledClaimTicketDate = false
        this.disabledClaimTicketNum = false,
        this.selected.forEach(item => {
          if(item.claim_ticket_number) this.disabledClaimTicketNum = 1;
          if(item.claim_ticket_date) this.disabledClaimTicketDate = 1;;
        })
        return this.disabledClaimTicketDate && this.disabledClaimTicketNum;
      },
      checkInspectionUpdateDis(){
        this.disabledInspectionTicketDate = false
        this.disabledInspectionReport = false,
        this.selected.forEach(item => {
          if(item.inspection_date) this.disabledInspectionTicketDate = 1;
          if(item.inspection_report) this.disabledInspectionReport = 1;;
        })
        return this.disabledInspectionTicketDate && this.disabledInspectionReport;
      },
      formatCurrency(value) {
        return Number(value).toLocaleString('en-IN');
      },
      deleteLastRow(){
        const index = this.rows.length- 1
        this.rows.splice(index,1)
      },
      validateDate(value) {
        const date1 = new Date(value)
        const date2 = new Date(this.today)
        date1.setHours(0,0,0,0)
        date2.setHours(0,0,0,0)
        if (date1 > date2) {
          return 'Date cannot be in the future';
        }
        return true;
      },
      dateFormat(date){
        const parts = date.split('-')
        if(Number(parts[0])<=31 )
          return parts.join('/')
        else return parts.reverse().join('/')
      },
      onInfoDataPress(event,field) {
        const mobile_field = ['Mobile Number of Claim Logged','Site POC 1 Mobile','Site POC 2 Mobile']
        const email_field = ['Email ID of Claim Logged','Site POC 1 Email ID','Site POC 2 Email ID']
        const specialCharsRegex = mobile_field.includes(field) ? /[!@#$%^&*()_+\-=\[a-zA-Z\]{};':"\\|,.<>\/?]/ : email_field.includes(field) ? /[!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]/ :  /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
        if (specialCharsRegex.test(event.key) || mobile_field.includes(field) && this.data_type_info.length > 9) {
          event.preventDefault();
        }
      },
      clearInvalidInput() {
      if (this.salvage_value <= 0) {
        this.salvage_value = null;
      }
    },
    clearInvalidInputApproved() {
      if (this.approved_amount <= 0) {
        this.approved_amount = null;
      }
    },
    }

  }
  </script>

  <style scoped>
  .v-dialog>.v-card>:has(.v-card__title){
  overflow-wrap: break-word !important;
  }
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }
  .custom-control_outlined button {
    min-height: 52px;
    border-width: 1px;
    border-radius: 4px;
    border-color: rgba(0,0,0,.42);
    border-style: solid;
  }
  .custom-control_outlined button:focus {
    outline: none;
  }
  .v-dialog:has(.filter-insurance){
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
  }
  .v-card__text > .row > .col hr{
  border-top: 0.5px solid #2D2D2D;
  }
  .my-autocomplete {
    background-color: blue;
    color: white;
  }
  /* .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  background-color: #1867c0 !important;
  color: #fff !important;
  margin-bottom: -35px !important;
  } */
  :deep(.field .v-input__control>.v-field--active) {
    background-color: #0357D0 !important;
    min-height: 36px;
  } 
  :deep(.field .v-input__control>.v-field--active>.v-field__field .v-label) {
    color: #fff !important;
  }
  :deep(.field .v-input__control>.v-field--active input){
    color: #fff;
  }
  :deep(.field .v-input__control>.v-field--active>.v-input__append-inner>.v-icon) {
    color: #fff !important;
  }
  :deep(.field .v-input__control>.v-field--active > .v-input__icon>.mdi-menu-down::before){
    color: #fff !important;
  }

  .alignitems{
    padding-left: 12px !important;
  }
  .item-selected {
    margin-top: 29px;
    position: absolute;
    left: 35%;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
      padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
      padding: 24px !important;
    }
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 318px) !important;
  }
  :deep(.assign_dispo_button .v-input__slot){
    min-height: 52px !important;
  }
  .filter_ui{
    margin-left: 32px !important;
    margin-top: 12px !important;
 }

  </style>
